export const API_PATH = 'reporting-flags/companies';
export const API_BASE = process.env.FINANCIAL_DOCS_API;
